<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  > 
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <DateRangePicker id="dashboard-daterangepicker" @update:date="handleRangeDate" />
        <OutlineButton v-if="false" btn-class="btn-sm" icon-class="fas fa-download fs-3" type="primary" btn-text="button.download" @click="downloadView" :isLoading="isLoadingDownload"/>
        <Button v-if="widgets?.length>0" 
          id="widgets-drawer-btn" data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end"
          btn-class="btn-sm" type="new" btn-text="stats.add" />

      </div>
    </template>  

    <template #layoutContent>
        <div class="row justify-content-between">
          <div class="col-12">
            <div class="card p-5 mb-8">
              <div class="row">
                <div v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)" class="col-12 col-md-6 col-lg-3 ">
                  <div class="card stat_class px-3 py-5 text-center">
                    <h3 class="font-weight-900 mb-2">{{ $t('dashboard.turnover') }}</h3>
                    <h3 class="text-primary">{{ $formatLocalAmount(dashboardStats.invoiceTurnover.invoiceTurnover) }} {{ defaultCurrency?.symbol }}</h3>
                  </div>
                </div>

                <div v-if="$canAccess(moduleAbilities.GENERAL_INVOICE)" class="col-12 col-md-6 col-lg-3 ">
                  <div class="card stat_class py-3">
                    <div class="row" style="padding-left: 10px;">
                      <div class="col-2 bg-success font-weight-900 fs-2 text-white text-center py-6" @click="goToInvoicesCount" style="border-radius: 8px; padding-top: 15px;">
                        {{dashboardStats.invoiceTurnover.invoicesCount}}
                      </div>
                      <div class="col-10">
                        <h3 class="font-weight-900 mb-3 text-success">{{ $t('dashboard.invoice') }}</h3>
                        <div class="d-flex justify-content-between">
                          <div class="card px-3 pt-2 w-50 me-2" @click="goToInvoicesPaid">
                            <h6 class="font-weight-900 text-success">
                              <span class="me-2">{{ dashboardStats.invoiceTurnover.invoicesPaidCount }}</span>
                              {{$t('dashboard.payed',dashboardStats.invoiceTurnover.invoicesPaidCount)}}
                            </h6>
                          </div>
                          <div class="card px-3 pt-2 w-50" @click="goToInvoicesUnpaid">
                            <h6 class="font-weight-900 text-danger">
                              <span class="me-2">{{ dashboardStats.invoiceTurnover.invoicesNotPaidCount }}</span>
                              {{$t('dashboard.notPayed', dashboardStats.invoiceTurnover.invoicesNotPaidCount)}}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-3 ">
                  <div class="card stat_class py-3 px-2">
                    <div class="row" style="padding-left: 10px;">
                      <div @click="goToUsersCount" class="col-2 bg-warning font-weight-900 fs-2 text-white text-center py-6" style="border-radius: 8px; padding-top: 15px;">
                        {{dashboardStats.users.activeUsersCount + dashboardStats.users.disableUsersCount}}
                      </div>
                      <div class="col-10">
                        <h3 class="font-weight-900 mb-3 text-warning">{{ $t('dashboard.user') }}</h3>
                        <div class="d-flex justify-content-between">
                          <div class="card px-3 pt-2 w-50 me-2" @click="goToUsersActifs">
                            <h6 class="font-weight-900 text-success">
                              <span class="me-2">{{ dashboardStats.users.activeUsersCount }}</span>
                              {{$t('dashboard.active',dashboardStats.users.activeUsersCount)}}
                            </h6>
                          </div>
                          <div class="card px-3 pt-2 w-50" @click="goToUsersInactifs">
                            <h6 class="font-weight-900 text-danger">
                              <span class="me-2">{{ dashboardStats.users.disableUsersCount }}</span>
                              {{$t('dashboard.inactive',dashboardStats.users.disableUsersCount)}}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-3 ">
                  <div class="card stat_class py-3 px-2">
                    <div class="row" style="padding-left: 10px;">
                      <div @click="goToContactsCount" class="col-2 font-weight-900 fs-2 text-white text-center py-6" style="background: #303D4E; border-radius: 8px; padding-top: 15px;">
                        {{dashboardStats.contacts.contactsCount}}
                      </div>
                      <div class="col-10">
                        <h3 class="font-weight-900 mb-3" style="color: #303D4E">{{ $t('dashboard.contact') }}</h3>
                        <div class="d-flex justify-content-between">
                          <div class="card px-3 pt-2 w-50 me-2" @click="goToContactsClients">
                            <h6 class="font-weight-900 text-success">
                              <span class="me-2">{{ dashboardStats.contacts.contactsClient }}</span>
                              {{$t('dashboard.customer',dashboardStats.contacts.contactsClient)}}
                            </h6>
                          </div>
                          <div class="card px-3 pt-2 w-120px" @click="goToContactsSuppliers">
                            <h6 class="font-weight-900 text-primary">
                              <span class="me-2">{{ dashboardStats.contacts.contactsSupplier }}</span>
                              {{$t('dashboard.supplier',dashboardStats.contacts.contactsSupplier)}}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!addedWidgets?.length && !loading && widgets?.length>0" class="col-3" id="widgets-drawer-btn" data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <div class="card h-100 flex-center bg-light-primary border-primary border border-dashed p-8">
                <i class="fas fa-plus display-4 text-primary"></i>
                <a href="#" class="text-hover-primary fs-5 fw-bolder mb-2">{{$t("stats.add")}}</a>
              </div>
            </div>
            <div class="widget-list mb-15 ">
              <StatsBasedOnWidget :start="query.start_date" :end="query.end_date"/>
            </div>
          </div>
          <DrawerWidgets/>
        
        </div> 
    </template>
  </SubLayout>
</template>
<script setup>
import {onMounted, ref, computed, nextTick} from "vue";
import {useStore} from "vuex";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import OutlineButton from "@/components/OutlineButton";
import Button from "@/components/Button.vue";
import StatsBasedOnWidget from "@/components/stats/StatsBasedOnWidget.vue";
import { $formatLocalAmount } from "@/mixins/Helpers";
import moduleAbilities from "@/composables/moduleAbilities";
import DrawerWidgets from "@/components/stats/DrawerWidgets.vue";

const store = useStore()

const title = ref("navigation.dashboard")
const breadcrumbs = ref([
  {
    name: 'navigation.dashboard',
    path: '/admin'
  }
])

const query = ref({
  start_date: '',
  end_date: '',
  limit: "10"
})

const loading = ref(false)

const widgets = computed(() => store.getters['stats/getWidgets'])

const addedWidgets = computed(() => store.getters['stats/getAddedWidgets'])
const dashboardStats = computed(() => store.getters['stats/getDashboardStats'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])


function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
  store.dispatch('stats/loadDashboardStats', range)
}



function loadData(){
  loading.value = true
  Promise.all([
    store.dispatch('stats/loadWidgets'),
    store.dispatch('stats/loadUserWidgets'),
  ]).finally(() => loading.value = false)
}

onMounted(() => {
  loadData()

})

</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  .end-0{
    right: -3% !important;
  }

  .vertical-line {
    width: 3px;
    height: 100%;
    background: var(--bs-gray-400);
    margin-right: 10px;
  }
  .grey-background {
    background-color: #f0f0f0;
  }
  .stat_class {
    background-color: var(--bs-semi-light-primary);
    border-radius: 8px;
    padding: 5px;
    width: auto;
  }
</style>
